import React from "react";

const membershipHighlights = [
    { value: "Daily", label: "New perspectives" },
    { value: "Exclusive", label: "Original films & series" },
    { value: "Independent", label: "No party line" },
    { value: "30+ years", label: "David Icke archive" },
];

const FrontProofStrip: React.FC = () => (
    <section id="proof" className="front-proof" aria-label="Membership highlights">
        <ul className="front-proof__inner">
            {membershipHighlights.map((highlight) => (
                <li className="front-proof__item" key={highlight.value}>
                    <strong>{highlight.value}</strong>
                    <span>{highlight.label}</span>
                </li>
            ))}
        </ul>
    </section>
);

export default FrontProofStrip;
